var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSelectDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9C0.5 13.6944 4.30558 17.5 9 17.5C13.6944 17.5 17.5 13.6944 17.5 9C17.5 4.30558 13.6944 0.5 9 0.5C4.30558 0.5 0.5 4.30558 0.5 9Z",
    stroke: "#CCCCCC",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.79289L11.2684 7.14645C11.4358 6.95118 11.7071 6.95118 11.8745 7.14645C12.0418 7.34171 12.0418 7.65829 11.8745 7.85355L9.30305 10.8536C9.13568 11.0488 8.86432 11.0488 8.69695 10.8536L6.12553 7.85355C5.95816 7.65829 5.95816 7.34171 6.12553 7.14645C6.29289 6.95118 6.56425 6.95118 6.73162 7.14645L9 9.79289Z",
    fill: "#77777C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_93_948",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 6,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.79289L11.2684 7.14645C11.4358 6.95118 11.7071 6.95118 11.8745 7.14645C12.0418 7.34171 12.0418 7.65829 11.8745 7.85355L9.30305 10.8536C9.13568 11.0488 8.86432 11.0488 8.69695 10.8536L6.12553 7.85355C5.95816 7.65829 5.95816 7.34171 6.12553 7.14645C6.29289 6.95118 6.56425 6.95118 6.73162 7.14645L9 9.79289Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_93_948)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSelectDown);
export default __webpack_public_path__ + "static/media/ico-select-down.ffff5723d305ed4949c057cc7952f12a.svg";
export { ForwardRef as ReactComponent };